import api from './api'

// Convierte la VAPID public key (base64url) al Uint8Array que pide applicationServerKey.
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const raw = atob(base64)
  const out = new Uint8Array(raw.length)
  for (let i = 0; i < raw.length; i += 1) out[i] = raw.charCodeAt(i)
  return out
}

export function pushSupported() {
  return (
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  )
}

export function isIOS() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent)
}

export function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  )
}

export async function getSubscription() {
  if (!pushSupported()) return null
  const reg = await navigator.serviceWorker.ready
  return reg.pushManager.getSubscription()
}

// Pide permiso, se suscribe y registra la suscripción en el backend.
// Lanza errores con códigos conocidos: 'unsupported' | 'ios-not-installed' | 'denied'.
export async function enablePush() {
  if (!pushSupported()) throw new Error('unsupported')
  // En iOS Web Push solo funciona con la PWA instalada (standalone).
  if (isIOS() && !isStandalone()) throw new Error('ios-not-installed')

  const permission = await Notification.requestPermission()
  if (permission !== 'granted') throw new Error('denied')

  const { data } = await api.get('/push/vapid-public-key')
  const vapidKey = data.publicKey || data.public_key || data

  const reg = await navigator.serviceWorker.ready
  let sub = await reg.pushManager.getSubscription()
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidKey),
    })
  }

  await api.post('/push/subscribe', sub.toJSON())
  return sub
}

export async function disablePush() {
  const sub = await getSubscription()
  if (!sub) return
  try {
    await api.post('/push/unsubscribe', { endpoint: sub.endpoint })
  } catch (e) {
    // si el backend falla igual desuscribimos del lado del navegador
  }
  await sub.unsubscribe()
}
